<template>
  <div>
    <Header></Header>
    <div class="exam-wrapper">
      <div class="report-wrap">
        <div class="report-title">
          <div @click="onClickLeft" class="back_class">
            <img src="../../assets/img/back.png" style="margin-right: 12px;width: 20px;height: 20px;" />
            <div>返回</div>
          </div>
          测评报告
        </div>
        <div class="report_content">
          <div class="topView">
            <div class="topCon">
              <div class="top_time">
                <span>答题时间：{{ detail.userTime }}</span>
                <span>提交时间：{{ detail.limitTime }}</span>
              </div>
              <div class="topcon1">
                <div class="top_left">
                  <div class="top_left_title">测评报告</div>
                  <div>
                    <img v-if="detail.grade == '优秀'" style="width: 80px" src="../../assets/mi/z_y.png" alt="" />
                    <img v-if="detail.grade == '良好'" style="width: 80px" src="../../assets/mi/z_l.png" alt="" />
                    <img v-if="detail.grade == '及格'" style="width: 80px" src="../../assets/mi/z_j.png" alt="" />
                    <img v-if="detail.grade == '有待提高'" style="width: 80px" src="../../assets/mi/z_tg.png" alt="" />
                  </div>
                </div>
                <div class="top_right">
                  <div style="display: flex; justify-content: space-between; width: 50%;">
                    <div style="text-align: center">
                      <div style="font-size: 18px; margin-bottom: 20px;">做对</div>
                      <div>{{ detail.rightNum }}</div>
                    </div>
                    <div style="text-align: center">
                      <div style="font-size: 18px; margin-bottom: 20px;">做错</div>
                      <div>{{ detail.wrongNum }}</div>
                    </div>
                    <div style="text-align: center">
                      <div style="font-size: 18px; margin-bottom: 20px;">未做</div>
                      <div>{{ detail.notDoNum }}</div>
                    </div>
                  </div>
                  <div class="top_right_content">{{ detail.comment }}</div>
                </div>
              </div>
            </div>
          </div>
          <div style="
                                                                            display: flex;
                                                                            align-items: center;
                                                                            padding: 0 14px;
                                                                            margin: 10px 0px;
                                                                          ">
            <img style="width: 32px; height: 28px; margin-right: 15px;" src="../../assets/mi/zs.png" alt="" />
            <div style="font-size: 26px; font-weight: 600;">知识模块评级</div>
          </div>
          <div v-for="(item, index) in detail.listc" :key="index">
            <div class="listcon">
              <div style="
                                                                                color: #303b45;
                                                                                font-size: 26px;
                                                                                font-weight: 600;
                                                                                margin-bottom: 30px;
                                                                              ">
                {{ item.categoryName }}
              </div>
              <div style="display: flex; margin-bottom: 20px">
                <img v-if="item.grade == '优秀'" style="width: 35px; height: 35px; margin-right: 15px;"
                  src="../../assets/mi/my.png" alt="" />
                <img v-if="item.grade == '良好'" style="width: 35px; height: 35px; margin-right: 15px;"
                  src="../../assets/mi/yb.png" alt="" />
                <img v-if="item.grade == '及格'" style="width: 35px; height: 35px; margin-right: 15px;"
                  src="../../assets/mi/jg.png" alt="" />
                <img v-if="item.grade == '有待提高'" style="width: 35px; height: 35px; margin-right: 15px;"
                  src="../../assets/mi/cha.png" alt="" />
                <div style="color: #303b45; font-size: 22px; line-height: 35px;">
                  评级：{{ item.grade }}
                </div>
              </div>
              <div style="color: #9b9faa; font-size: 20px; margin-bottom: 30px; text-align: justify;">
                {{ item.comment }}
              </div>
              <!-- <div style="color: #0F6CF5;font-size: 22px;" v-if="item.grade != '优秀'">推荐您学习{{ item.categoryName }}等课程</div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import { getExamMnResult } from '@/api/apper.js'
export default {
  name: 'result',
  components: { Header },
  data() {
    return {
      detail: {}, // 详情列表
      userPaperId: '', // 用户此次考试生成的考题id,每次测试会生成新的id
    }
  },
  created() {
    this.userPaperId = this.$route.query.userPaperId
    this.token = window.localStorage.getItem('token')
    this.getExamResultList()
  },
  methods: {
    getExamResultList() {
      getExamMnResult({ id: this.userPaperId }, { Authorization: this.token }).then(res => {
        this.detail = res.data
        this.detail.userTime = this.formatTime(this.detail.userTime)
      }).catch(res => {
        this.detail = {}
      })
    },
    formatTime(seconds) {
      var hours = Math.floor(seconds / 3600);
      var minutes = Math.floor((seconds % 3600) / 60);
      var secs = seconds % 60;
      hours = hours > 9 ? hours : '0' + hours
      minutes = minutes > 9 ? minutes : '0' + minutes
      secs = secs > 9 ? secs : '0' + secs
      return hours + ':' + minutes + ':' + secs;
    },
    // 返回列表
    onClickLeft() {
      // this.$router.push(`/ztDetails/${this.specId}`)
      // this.$router.go('-1')
      this.$router.push('/index')
    },
  },
}
</script>

<style lang="less" scoped>
.exam-wrapper {
  width: 1200px;
  margin: 0 auto;
  margin-top: 120px;
}

.report-wrap {
  width: 100%;
  background: #F5F5F4;
  padding-bottom: 60px;

  .report-title {
    width: 100%;
    height: 70px;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    text-align: center;
    line-height: 70px;
    position: relative;
    background: #fff;
    border-radius: 8px;

    .back_class {
      position: absolute;
      width: 72px;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #666666;
      cursor: pointer;
      display: flex;
      align-items: center;
      left: 20px;

      div {
        display: inline-block;
      }
    }
  }

  .topView {
    padding: 10px 5px 5px 5px;

    .top_time {
      text-align: left;
      padding-bottom: 20px;
      border-bottom: 1px solid rgba(255, 255, 255, .24);
      margin-bottom: 20px;
      margin-left: 20px;

      span {
        display: inline-block;
        font-size: 20px;
        color: #fff;

        &:first-child {
          margin-right: 70px;
        }
      }
    }

    .topCon {
      padding: 50px 50px 50px 55px;
      color: #fff;
      display: flex;
      flex-direction: column;
      width: auto;
      height: auto;
      background: url('../../assets/mi/background.png') no-repeat;
      background-size: 100% 100%;
      min-height: 200px;
    }

    .topcon1 {
      display: flex;
      width: 100%;
      height: auto;
      align-items: flex-start;
      justify-content: flex-start;

      .top_left {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-right: 50px;
        width: 130px;
        position: relative;

        .top_left_title {
          margin-bottom: 25px;
          font-size: 22px;
          font-weight: 500;
          text-align: center;
          width: 100%;
        }
      }

      .top_right {
        flex: 1;
        text-align: center;
        font-size: 30px;
        margin-top: 6px;

        .top_right_content {
          font-size: 15px;
          text-align: justify;
          margin-top: 10px;
        }
      }
    }
  }

  .listcon {
    background: url('../../assets/mi/bg.png') no-repeat;
    background-size: 100% 100%;
    padding: 35px 40px;
    text-align: left;
  }
}
</style>